import { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import SearchResultsSkeleton from '../../search/SearchResults/SearchResultsSkeleton';

interface ResultContainerProps {
  loading: boolean;
  noResults: boolean;
  width?: string | number;
  mr?: string | number;
  center?: boolean;
}

export const ResultContainer: FC<ResultContainerProps> = ({
  loading,
  noResults,
  children,
  width,
  mr,
}) => {
  if (loading) {
    return (
      loading && (
        <Stack sx={{ width: width || '100%', mr }}>
          <SearchResultsSkeleton />
        </Stack>
      )
    );
  }

  if (noResults) {
    return (
      <Box sx={{ py: 0.5 }}>
        <Typography variant={'h6'}>{'No Results Found'}</Typography>
      </Box>
    );
  }

  return <Stack sx={{ py: 0.5, width: '100%' }}>{children}</Stack>;
};
